import DatetimeScatterChart from "./DatetimeScatterChart";

export default DatetimeScatterChart;
